import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    raReports: {
        data: [],
    },
    bdmReports: {
        data: [],
    },
    recruiterReport: {
        data: [],
    },
    recruiterEmailDelivaryReport: null,
    recruiterEmailDelivaryReportNewData: [],
    //emailReporst
    emailsSkipped: [],
    emailsQueued: [],
    emailsSent: [],
    emailsFailed: [],
    emailOpened: [],
    emailClicked: [],
    emailTemporaryFailed: [],
    emailPermanentFailed: [],
    emailSpamComplained: [],
    emailUnsubScribe: [],
};

const reportsSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
        reportsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        reportsSuccess: (state, action) => {
            state.loading = false;
            state.raReports.data = action.payload.data
        },
        reportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        bdmReportsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        bdmReportsSuccess: (state, action) => {
            state.loading = false;
            state.bdmReports.data = action.payload.data
        },
        bdmReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        recruiterReportsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        recruiterReportsSuccess: (state, action) => {
            state.loading = false;
            state.recruiterReport.data = action.payload.data
        },
        recruiterEmailDelivaryReportStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        recruiterEmailDelivaryReportSuccess: (state, action) => {
            state.loading = false;
            state.recruiterEmailDelivaryReport = action.payload.data
        },
        recruiterEmailDelivaryReportNewStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        recruiterEmailDelivaryReportNewSuccess: (state, action) => {
            state.loading = false;
            state.recruiterEmailDelivaryReportNewData = action.payload.data;
        },
        recruiterEmailDelivaryReportNewFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        // SKIPPED
        emailsSkippedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailsSkippedSuccess: (state, action) => {
            state.loading = false;
            state.emailsSkipped = action.payload.data;
        },
        emailsSkippedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // QUEUED
        emailsQueuedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailsQueuedSuccess: (state, action) => {
            state.loading = false;
            state.emailsQueued = action.payload.data;
        },
        emailsQueuedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // SENT
        emailsSentStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailsSentSuccess: (state, action) => {
            state.loading = false;
            state.emailsSent = action.payload.data;
        },
        emailsSentFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // FAILED
        emailsFailedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailsFailedSuccess: (state, action) => {
            state.loading = false;
            state.emailsFailed = action.payload.data;
        },
        emailsFailedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // OPENED
        emailOpenedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailOpenedSuccess: (state, action) => {
            state.loading = false;
            state.emailOpened = action.payload.data;
        },
        emailOpenedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // CLICKED
        emailClickedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailClickedSuccess: (state, action) => {
            state.loading = false;
            state.emailClicked = action.payload.data;
        },
        emailClickedFailure: (state) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // TEMP FAILED
        emailTemporaryFailedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailTemporaryFailedSuccess: (state, action) => {
            state.loading = false;
            state.emailTemporaryFailed = action.payload.data;
        },
        emailTemporaryFailedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // PERMANENT FAILED
        emailPermanentFailedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailPermanentFailedSuccess: (state, action) => {
            state.loading = false;
            state.emailPermanentFailed = action.payload.data;
        },
        emailPermanentFailedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // SPAM COMPLAINT
        emailSpamComplainedStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailSpamComplainedSuccess: (state, action) => {
            state.loading = false;
            state.emailSpamComplained = action.payload.data;
        },
        emailSpamComplainedFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },

        // UNSUBSCRIBE
        emailUnsubScribeStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        emailUnsubScribeSuccess: (state, action) => {
            state.loading = false;
            state.emailUnsubScribe = action.payload.data;
        },
        emailUnsubScribeFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
    },
});

export const {
    reportsStart,
    reportsSuccess,
    reportsFailure,
    bdmReportsStart,
    bdmReportsSuccess,
    bdmReportsFailure,
    recruiterReportsStart,
    recruiterReportsSuccess,
    recruiterEmailDelivaryReportStart,
    recruiterEmailDelivaryReportSuccess,
    recruiterEmailDelivaryReportNewStart,
    recruiterEmailDelivaryReportNewSuccess,
    recruiterEmailDelivaryReportNewFailure,
    emailsSkippedStart,
    emailsSkippedSuccess,
    emailsSkippedFailure,
    emailsQueuedStart,
    emailsQueuedSuccess,
    emailsQueuedFailure,
    emailsSentStart,
    emailsSentSuccess,
    emailsSentFailure,
    emailsFailedStart,
    emailsFailedSuccess,
    emailsFailedFailure,
    emailOpenedStart,
    emailOpenedSuccess,
    emailOpenedFailure,
    emailClickedStart,
    emailClickedSuccess,
    emailClickedFailure,
    emailTemporaryFailedStart,
    emailTemporaryFailedSuccess,
    emailTemporaryFailedFailure,
    emailPermanentFailedStart,
    emailPermanentFailedSuccess,
    emailPermanentFailedFailure,
    emailSpamComplainedStart,
    emailSpamComplainedSuccess,
    emailSpamComplainedFailure,
    emailUnsubScribeStart,
    emailUnsubScribeSuccess,
    emailUnsubScribeFailure,
} = reportsSlice.actions;

export default reportsSlice.reducer;
